<template>
    <v-menu v-model="sonModelValue" :close-on-content-click="false" scroll-strategy="block">
        <template v-slot:activator="{ props }">
            <div class="d-flex align-start">
                <v-btn v-bind="props" elevation="0" class="color-picker-button align-start justify-end px-6 py-5 d-flex"
                    :style="{ 
                        backgroundColor: sonModelValue ? selectedColor : modelValue || 'white',
                        borderColor: selectedColor ? '#FFFFFF' : '#000000'
                     }">
                    <v-icon size="small">
                        <v-img :src="require('@/ai_studio/assets/icons/color-picker-pencil.svg')"></v-img>
                    </v-icon>
                </v-btn>

                <div class="swatches-container ml-2">
                    <div v-for="(color, index) in swatches" :key="index" class="swatch"
                        :style="{ backgroundColor: color }" @click="selectSwatch(color)"></div>
                </div>
            </div>
        </template>

        <v-list class="mt-5">
            <v-list-item>
                <v-color-picker elevation="0" v-model="selectedColor" class="color-picker ma-2">
                </v-color-picker>
                <div class="d-flex justify-end ga-3 px-4 py-2">
                    <v-btn class="px-6 py-5 d-flex" rounded="xl" color="neutral-35" variant="outlined" @click="cancelSelection">Cancelar</v-btn>
                    <v-btn class="px-6 py-5 d-flex" rounded="xl" color="primary-60" @click="applySelection">Aplicar</v-btn>
                </div>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({ 
    modelValue: { type: String, default: null },
    swatches: { 
        type: Array, 
        default: () => [
            '#979C9F', '#607D8B', '#24292B', '#9B59B6', '#71368A', '#E91E63', '#F1C40F', '#C27C0E', '#E67E22', '#E74C3C', '#A84300', '#992D22', '#2ECC71', '#1ABC9C', '#26A98F', '#046B57', '#3498DB', '#206694'
        ]
    }
});

const sonModelValue = ref(false);
const selectedColor = ref(props.modelValue);

const applySelection = () => {
    emit('update:modelValue', selectedColor.value);
    sonModelValue.value = false;
};

const selectSwatch = (color) => {
    emit('update:modelValue', color);
    selectedColor.value = color;
};

const cancelSelection = () => {
    selectedColor.value = props.modelValue;
    sonModelValue.value = false;
};

watch(sonModelValue, (value) => {
    if (value) {
        selectedColor.value = props.modelValue;
    }
});

watch(() => props.modelValue, (value) => {
    if (!sonModelValue.value) {
        selectedColor.value = value;
    }
});
</script>

<style scoped>
.color-picker-button {
    width: 40px;
    height: 40px;
    min-width: 0;
    min-height: 0;
    border-radius: 8px;
    border: 1px solid rgb(var(--v-theme-neutral-10));
    padding: 4px !important;
    cursor: pointer;
    overflow: hidden;
}

.swatches-container {
    display: flex;
    flex-wrap: wrap;
    width: 244px;
    gap: 8px;
}

.swatch {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.color-picker-button:deep(.v-btn__overlay) {
    opacity: 0 !important;
    background-color: transparent !important;
}

.color-picker:deep(.v-color-picker-preview__dot) {
    display: none !important;
}

.color-picker:deep(.v-color-picker-edit > *:last-child) {
    order: 0;
}

.color-picker:deep(.v-color-picker-edit > *:not(:last-child)) {
    order: 1;
}

:deep(.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line) {
    padding-inline: 14px;
    padding-block: 12px;
}

:deep(.v-color-picker-edit__input input) {
    background-color: #FFF !important;
    border: 1px solid #E5E8E8;
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-family: 16px;
    line-height: 24px;
    letter-spacing: 0px;
}
</style>